import { render, staticRenderFns } from "./dietitian.vue?vue&type=template&id=177bedd5&scoped=true&"
import script from "./dietitian.vue?vue&type=script&lang=js&"
export * from "./dietitian.vue?vue&type=script&lang=js&"
import style0 from "./dietitian.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"
import style1 from "./dietitian.vue?vue&type=style&index=1&id=177bedd5&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "177bedd5",
  null
  
)

export default component.exports